import React from 'react';
import { Field } from 'formik';

import FormikControl from '../../../../Components/formik/FormikControl';
import { capHelpText, feisCapData, gradeCapData, lavelCap } from '../../../../helper/OrgDataArrays';
import { handleWheel, handleKeyDown } from '../../../../helper/handleActions';


const CapOptions = ({ formik, props, levelCap, SetlevelCap }) => {
    // Derived from the form, so a reloaded Global Cap event shows its input.
    const showGlobalCap = formik.values.cap?.capType === 'Global Cap';
    return <>
        <div><h3 className="EventDateOrg">Options</h3></div>
        <div className={formik.errors.cap?.capType && formik.touched.cap?.capType ? '' : 'input-control'}>
            <label
                style={{ fontSize: '12px' }}
                className={formik.errors.cap?.capType && formik.touched.cap?.capType ? 'label-select-org-error' : 'org-select'}
            >
                Cap:
            </label>
            <FormikControl
                className={formik.errors.cap?.capType && formik.touched.cap?.capType ? 'input-box-select-error ' : 'input-box-org-select'}
                control="select"
                name="cap.capType"
                onWheel={handleWheel}
                onKeyDown={handleKeyDown}
                showAs="Select"
                options={props.type === "feis" ? feisCapData : gradeCapData}
                id="schoolSelect"
                setFieldValue={formik.setFieldValue}
                onChange={(e) => {
                    formik.setFieldTouched('cap.capType');
                    formik.setFieldValue('cap.value', '');
                    formik.setFieldValue('cap.grades', '');
                    formik.setFieldValue('cap.champ', '');
                    formik.setFieldTouched('cap.value', false);
                    formik.setFieldTouched('cap.grades', false);
                    formik.setFieldTouched('cap.champ', false);
                    formik.setFieldValue('cap.capType', e.target.value);
                    SetlevelCap(e.target.value === 'Level Cap');
                }}
                onClick={() => {
                    formik.validateField('cap.capType')
                    formik.validateForm()
                }}
            />
        </div>
        {capHelpText[formik.values.cap?.capType] && (
            <div className="subKey mb-2">{capHelpText[formik.values.cap?.capType]}</div>
        )}
        {levelCap && (
            <div className="levelCap-Values">
                {renderLevelCapInputs(formik, 0, "grades", formik.touched.cap?.grades)}
                {renderLevelCapInputs(formik, 1, "champ", formik.touched.cap?.champ)}
            </div>
        )}
        {levelCap && levelCapError(formik) && <div className="error">{levelCapError(formik)}</div>}

        {showGlobalCap && (
            <>
                {renderNumberInput(formik)}
                {formik.errors.cap?.value && formik.touched.cap?.value && <div className="error">{formik.errors.cap?.value}</div>}
                <div />
                <br />
            </>
        )}
    </>
}

export default CapOptions

const renderNumberInput = formik => {
    return <Field
        className={formik.errors.cap?.value && formik.touched.cap?.value ? 'input-box-org-error mt-2' : 'input-box-org mt-2'}
        type="number"
        name="cap.value"
        placeholder="Maximum dancers"
        step="1"
        min="1"
        onWheel={handleWheel}
        onKeyPress={(e) => { if (e.key === 'e') { e.preventDefault(); } }}
    />
}

const renderLevelCapInputs = (formik, index, keyWord, touchvalidation) => {
    return <div className={!formik.values.cap?.grades && !formik.values.cap?.champ && touchvalidation ? '' : 'input-control'}>
        <label
            className={!formik.values.cap?.grades && !formik.values.cap?.champ && touchvalidation ? 'label-select-org-error' : 'org-select'}
        >
            {lavelCap[index].key}
            <div className="subKey">{lavelCap[index].subKey}</div>
        </label>
        <Field
            className={!formik.values.cap?.grades && !formik.values.cap?.champ && touchvalidation ? 'input-box-org-error' : 'input-box-org'}
            type="number"
            name={keyWord === "grades" ? "cap.grades" : "cap.champ"}
            placeholder="No limit"
            step="1"
            min="0"
            onWheel={handleWheel}
            onKeyPress={(e) => { if (e.key === 'e') { e.preventDefault(); } }}
        />
    </div>
}

// Validation message for the Level Cap inputs, once either has been touched.
const levelCapError = (formik) =>
  (formik.touched.cap?.grades || formik.touched.cap?.champ) &&
  (formik.errors.cap?.grades || formik.errors.cap?.champ);
